import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { BookButton, BookModal, BookTexField, ImageUploader } from '../../components';
import { AnnouncementValidation } from '../Announcements/validation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CreateAnnouncement, UpdateAnnouncement } from "../../DAL/Announcements/announcements";
import { enqueueSnackbar } from "notistack";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const AnnouncementModals = ({
  open,
  setOpen,
  action,
  singleAnnouncement,
  tableCells,
  handleGetAnnouncementData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const handleAddAnnouncement = async(values) => { 
    setIsLoading(true);
    const data = {
        title: values?.title,
        description: values?.description,
        link: values?.link || null,
        scheduledAt: values?.scheduledAt ? dayjs(values.scheduledAt).toISOString() : null,
        url: values?.url || null,
      };
    const response = await CreateAnnouncement(data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetAnnouncementData()
      setOpen(false);
      formik.handleReset();
      enqueueSnackbar("Announcement created successfully!", { variant: "success" });
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const handleUpdateAnnouncement = async(values) => {
    setIsLoading(true);
    const data = {
      title: values?.title,
      description: values?.description,
      link: values?.link || null,
      scheduledAt: values?.scheduledAt ? dayjs(values.scheduledAt).toISOString() : null,
      url: values?.url || null,
    };
    const response = await UpdateAnnouncement(values?.id, data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetAnnouncementData()
      setOpen(false);
      formik.handleReset();
      enqueueSnackbar("Announcement updated successfully!", { variant: "success" });
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id:
        action !== 'add' && singleAnnouncement && singleAnnouncement.id
          ? singleAnnouncement.id
          : '',
      title:
        action !== 'add' && singleAnnouncement && singleAnnouncement.title
          ? singleAnnouncement.title
          : '',
      description:
        action !== 'add' && singleAnnouncement && singleAnnouncement.description
          ? singleAnnouncement.description
          : '',
      link:
        action !== 'add' && singleAnnouncement && singleAnnouncement.link
          ? singleAnnouncement.link
          : '',
      scheduledAt:
        action !== 'add' && singleAnnouncement && singleAnnouncement.scheduledAt
          ? dayjs(singleAnnouncement.scheduledAt)
          : null,
      url:
        action !== 'add' && singleAnnouncement && singleAnnouncement.url
          ? singleAnnouncement.url
          : '',
    },
    validationSchema: AnnouncementValidation,
    onSubmit: values => {   
      setIsLoading(true);
      if (action === 'add') {
        handleAddAnnouncement(values);
      } else {
        handleUpdateAnnouncement(values);
      }
    },
  });

  return (
    <BookModal
      open={open}
      formik={formik}
      setOpen={setOpen}
      title='Announcement'
      subtitle={`${action === 'add' ? 'Add' : 'Edit'} Announcement`}
    >
      {tableCells &&
        tableCells.map(t => {
          if (t.id !== 'actions' && t.id !== 'createdAt' && t.id !== 'id' && t.id !== 'url' && t.id !== 'link' && t.id !== 'scheduledAt') {
            return (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
                multiline={t.id === 'description'}
                rows={t.id === 'description' ? 4 : 1}
              />
            );
          }
          return null;
        })}
      <BookTexField
        formik={formik}
        name='link'
        label='Link'
        placeholder='Enter Link URL'
        key='link-field'
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label="Scheduled At"
          value={formik.values.scheduledAt}
          onChange={(newValue) => {
            formik.setFieldValue('scheduledAt', newValue);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: formik.touched.scheduledAt && Boolean(formik.errors.scheduledAt),
              helperText: formik.touched.scheduledAt && formik.errors.scheduledAt,
              sx: { marginBottom: '1rem' }
            }
          }}
        />
      </LocalizationProvider>
      <ImageUploader
        name='url'
        imageUrl={formik?.values?.url}
        callBackResponse={imageResponse => formik?.handleChange(imageResponse)}
      />
      <BookButton
        onSubmit={formik.handleSubmit}
        title={`${action === 'add' ? 'Add' : 'Update'}`}
        type='primary'
        variant='contained'
        isLoading={isLoading}
        sx={{
          top: '0.625rem',
          marginBottom: '0.625rem'
        }}
      />
    </BookModal>
  );
};

export default AnnouncementModals;
